import { createIntl, IntlShape, OptionalIntlConfig } from '@formatjs/intl';
import { defaultLocale } from './constants';
import { getTimeZoneFromCookie } from './helpers/getTimeZoneFromCookie';

let intl = createIntl(buildIntlConfig());

export function buildIntlConfig(locale = defaultLocale): OptionalIntlConfig {
  const timeZone = getTimeZoneFromCookie();
  return {
    locale,
    messages: {},
    ...(timeZone && { timeZone })
  };
}

export function setIntl(newIntl: IntlShape<string>) {
  intl = newIntl;
}

export { intl };
